import { head } from '../../../utils/helper/lodash_replacements';
export class ChoiceSelections {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get latestSelection() {
        return head(this.question.selections);
    }
}
